import { Component, Inject, OnInit } from '@angular/core';
import { QRCodeComponent } from '../qrcode/qrcode.component';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-qrcodedetailclose',
  templateUrl: './qrcodedetailclose.component.html',
  styleUrls: ['./qrcodedetailclose.component.scss']
})
export class QrcodedetailcloseComponent implements OnInit {

  constructor( @Inject(MAT_DIALOG_DATA) public data: any,) { }

  ngOnInit(): void {
  }

  getColumnNames(row: any): string[] {
    return Object.keys(row);
  }
}
